import { getTypographyMetric, getTypographyMetricOverride } from '../../../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Flex } from 'front-commons/ds/components/Flex';
import { Button } from 'front-commons/ds/components/Button';
import { Typography } from 'hype-ds';
import { useHeader } from '../../../../../../../../context';

export function ShowCategoriesMobile() {
	const {
		categories: { setShowCategories },
	} = useHeader();

	const { fontSizes } = useTheme();

	return (
		<Flex
			as={Button}
			gap="8px"
			position="relative"
			alignItems="center"
			justifyContent="center"
			noShrink
			raw={{
				"[data-component='Typography']": { display: 'inline' },
				"[data-header-text='ShowCategoriesMobile-metric-1']": {
					fontSize: getTypographyMetricOverride(fontSizes['16']),
					lineHeight: getTypographyMetricOverride(fontSizes['24']),
				},
			}}
			leftIcon={{
				color: '--text-link',
				name: 'menu',
			}}
			onClick={() => setShowCategories(true)}
			variant="none"
		>
			<Typography
				data-header-text="ShowCategoriesMobile-metric-1"
				textAlign="inherit"
				fontSize={getTypographyMetric(fontSizes['16'])}
				fontWeight="600"
				lineHeight={getTypographyMetric(fontSizes['24'])}
				color="--hympar-blue-700"
			>
				Categorias
			</Typography>
		</Flex>
	);
}
